// removed by extract-text-webpack-plugin
module.exports = {"SearchBox":"SearchBox_SearchBox__1EmM","closeButton":"SearchBox_closeButton__1GYP","suggestion":"SearchBox_suggestion__1sHB","break":"SearchBox_break__2HjD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Map/SearchBox/SearchBox.scss
// module id = 535
// module chunks = 0